
import actions from './actions'

export default function extendOrders (storeOrders) {
  storeOrders.actions = actions
  return storeOrders
}
